// Backend'deki ShiftKurallari.HaftaBaslangici ile aynı mantık: hafta Pazartesi'den başlar.
export function haftaBaslangici(tarih) {
  const d = new Date(tarih);
  const gun = d.getDay(); // 0=Pazar, 1=Pazartesi ... 6=Cumartesi
  const fark = (gun + 6) % 7; // Pazartesi'ye kaç gün geriye gidilecek
  d.setDate(d.getDate() - fark);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function toISODate(d) {
  const yil = d.getFullYear();
  const ay = String(d.getMonth() + 1).padStart(2, '0');
  const gun = String(d.getDate()).padStart(2, '0');
  return `${yil}-${ay}-${gun}`;
}

export function haftaGunleri(haftaBas) {
  const gunler = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(haftaBas);
    d.setDate(d.getDate() + i);
    gunler.push(d);
  }
  return gunler;
}

const GUN_ADLARI = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
export function gunAdi(d) {
  return GUN_ADLARI[new Date(d).getDay()];
}

const GUN_ADLARI_KISA = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];
export function gunAdiKisa(d) {
  return GUN_ADLARI_KISA[new Date(d).getDay()];
}

export function tarihTR(d) {
  const t = new Date(d);
  return t.toLocaleDateString('tr-TR');
}

// "YYYY-MM" formatındaki bir ay için, o ayla kesişen tüm haftaların (Pzt başlangıcı) listesini döner.
export function haftalarByAy(ayYYYYMM) {
  const [yil, ay] = ayYYYYMM.split('-').map(Number);
  const aySonu = new Date(yil, ay, 0);
  let bas = haftaBaslangici(new Date(yil, ay - 1, 1));
  const haftalar = [];
  while (bas <= aySonu) {
    haftalar.push(new Date(bas));
    bas = new Date(bas);
    bas.setDate(bas.getDate() + 7);
  }
  return haftalar;
}

export function ayYYYYMM(d) {
  const t = new Date(d);
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}`;
}

// Verilen hafta başlangıcı (ISO) bugünün haftasıysa "(Bu Hafta)", önümüzdeki haftaysa
// "(Önümüzdeki Hafta)" döner; diğer haftalarda boş string.
export function haftaEtiket(haftaISO) {
  const buHaftaISO = toISODate(haftaBaslangici(new Date()));
  if (haftaISO === buHaftaISO) return '  (Bu Hafta)';
  const onumuzdeki = new Date(haftaBaslangici(new Date()));
  onumuzdeki.setDate(onumuzdeki.getDate() + 7);
  if (haftaISO === toISODate(onumuzdeki)) return '  (Önümüzdeki Hafta)';
  return '';
}
